import { render } from "./PublishedPages.vue?vue&type=template&id=50db79f4&scoped=true"
import script from "./PublishedPages.vue?vue&type=script&lang=js"
export * from "./PublishedPages.vue?vue&type=script&lang=js"

import "./PublishedPages.vue?vue&type=style&index=0&id=50db79f4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50db79f4"]])

export default __exports__